import api from './api';

export interface CurrencySettings {
  currency_display_mode: 'dual' | 'eur_only';
  bgn_to_eur_rate: number;
}

export interface UpdateCurrencySettingsRequest {
  currency_display_mode: 'dual' | 'eur_only';
  bgn_to_eur_rate?: number;
}

export const settingsService = {
  // Get currency settings (public endpoint)
  getCurrencySettings: async (): Promise<CurrencySettings> => {
    const response = await api.get('/settings/currency');
    return response.data.data;
  },

  // Update currency settings (admin only)
  updateCurrencySettings: async (settings: UpdateCurrencySettingsRequest): Promise<CurrencySettings> => {
    const response = await api.put('/admin/settings/currency', settings);
    return response.data.data;
  },

  // Get all settings (admin only)
  getAllSettings: async (): Promise<Record<string, string>> => {
    const response = await api.get('/admin/settings');
    return response.data.data;
  },

  // Update a specific setting (admin only)
  updateSetting: async (key: string, value: string, type = 'string', description?: string): Promise<void> => {
    await api.put('/admin/settings', {
      key,
      value,
      type,
      description
    });
  }
};

export default settingsService;